export function Sunlight({ className }: { className?: string }) {
  return (
    <div className={className}>
      {/* First ray */}
      <div
        className="absolute flex items-center justify-center"
        style={{
          height: 501.496,
          width: 345.628,
          left: 'calc(50% + 78.19px)',
          top: 'calc(50% - 212.25px)',
          transform: 'translate(-50%, -50%)',
          animation: 'sunray-pulse-a 3.5s ease-in-out infinite',
        }}
      >
        <div
          className="rotate-[26.97deg]"
          style={{
            animation: 'sunray-sway 5s ease-in-out infinite',
          }}
        >
          <div
            style={{
              height: 493.031,
              width: 136.902,
              filter: 'blur(6px)',
              backgroundImage:
                'linear-gradient(187.15deg, rgba(250, 255, 183, 0.7) 1.683%, rgba(244, 255, 104, 0) 77.252%)',
            }}
          />
        </div>
      </div>
      {/* Second ray */}
      <div
        className="absolute flex items-center justify-center"
        style={{
          height: 530.187,
          width: 325.508,
          left: 'calc(50% + 251.13px)',
          top: 'calc(50% - 113.43px)',
          transform: 'translate(-50%, -50%)',
          animation: 'sunray-pulse-b 3s ease-in-out infinite',
          animationDelay: '0.8s',
        }}
      >
        <div
          className="rotate-[26.97deg]"
          style={{
            animation: 'sunray-sway 4.2s ease-in-out infinite',
            animationDelay: '1.2s',
          }}
        >
          <div
            style={{
              height: 551.98,
              width: 84.326,
              filter: 'blur(3px)',
              backgroundImage:
                'linear-gradient(192.844deg, rgba(250, 255, 183, 0.7) 39.104%, rgba(244, 255, 104, 0) 77.252%)',
            }}
          />
        </div>
      </div>
    </div>
  )
}
